import { Box, Tab, Tabs, TextField, Typography, getContrastRatio } from "@mui/material";
import { useEffect, useState } from "react";
import CustomAlert from "../../events/components/CustomAlert"
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import { useNavigate } from "react-router-dom";
import { generateLighterContrastColor } from "../../../utils/commonServices";
import useCustomTheme from "../../../theme/useCustomTheme";
import { updateProjectState } from "../../../redux/projectSlice";
import DocumentDropzone from "./DocumentDropzone";
import { getAllEventNotes, updateNotesToEditor } from "../actions";
import { getTeamEvents } from "../../teamsdashboard/actions";
import { getAllEvents } from "../../dashboard/actions";
import UploadedDocumentsTable from "./UploadedDocumentsTable";
import CustomTooltip from "../../../components/CustomTooltip";
import CustomButton from "../../../components/CustomButton";
import { LoadingButton } from "@mui/lab";
import usePermissions from "../../../hooks/usePermissions";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { PERMISSION, uploadCategory } from "../../../constants/constants";


const UploadDocumentsPopup = (props) => {
    // const { event  } = props
    const {uploadProps} = props;
    const {
      selectedFiles, setSelectedFiles,
      uploadsInProgress, setUploadsInProgress,
      uploadStatus, setUploadStatus,
      progress, setProgress, uploadFiles,
      requestController, setRequestController,
      actionAfterSuccessfulUpload
    } = uploadProps;
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const projectReducer = useSelector((state) => state.projectReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const [hasPermission] = usePermissions()
    const [uploadedVideosArray, setUploadedVideosArray] = useState([]);
    const [uploadedNotes , setUploadedNotes] = useState (projectReducer?.uploaded_event_notes)
    const [acceptType, setAcceptType] = useState('')
    const [disableSubmit, setDisableSubmit] = useState(true)
    const [theme] = useCustomTheme()

    const [activeTab, setActiveTab] = useState(projectReducer?.documents_popup_tab === 'notes' ? 'notes' : 'upload')
    const [editMode, setEditMode] = useState(false)
    const [description, setDescription] = useState(commonReducer?.event_details?.description)

    const handleClose = () => {
        dispatch(updateProjectState({upload_documents_to_editor_popup : false}))
    };

    const handleFocus = (event) => {
      const length = event.target.value?.trim()?.length;
      event.target.setSelectionRange(length, length);
    };

    const handleTabChange = (event, newValue) => {
      setActiveTab(newValue)
    };

    const convertToEditMode = ()=>{
      setEditMode(true)
    }

    const convertToViewMode = ()=>{
      setEditMode(false)
    }

    const saveEditNoteDescription =()=>{
      const payload = {
        id: commonReducer?.production_event_id,
        description: description
      }
      updateNotesToEditor(payload, dispatch, saveNoteCallback)
    }

    const saveNoteCallback = ()=>{
      !!teamsReducer.selected_team ?  getTeamEvents({  team_id: teamsReducer?.selected_team?.id}, dispatch) :    getAllEvents(dispatch);
      convertToViewMode()
    }

  useEffect(()=>{
    getAllEventNotes({event_id: commonReducer?.production_event_id}, dispatch)
  },[])

  useEffect(() => {
     setUploadedNotes(projectReducer?.uploaded_event_notes)

  }, [ projectReducer?.uploaded_event_notes])

  const afterUploadCallback =()=>{
    getAllEventNotes({event_id: commonReducer?.production_event_id}, dispatch)
  }

    return (
        <CustomAlert
          open={projectReducer.upload_documents_to_editor_popup}
          handleClose={handleClose}
          height={{xs:'610px',md:'610px',lg:'630px' ,xl:'850px'}}
          width={{xs:'600px',md:'740px',lg:'780px',xl:'1170px'}}
          >
            <Box sx={{display:'flex', flexDirection:'column', height:'100%', }} px={4} pt={1} pb={2}>
              <Box flexGrow={1} pt={{xs:3,sm:1, md:1.5, lg:2.5, xl:3}} sx={{display:'flex', flexDirection:'column', minHeight:0}} >

                  <Box className='flex col' gap={{xs:0.5, lg:1}}  sx={{ flexShrink:0 }}>
                    <Box className='flex j-between a-center' style={{width:{xs:'90%', md:'80%'}}}>
                      <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'14px',sm:'14px',md:'16px',lg:'20px',xl:'30px'}}}>My Documents: Docs, PPT, and PDFs</Typography>
                    </Box>

                    <Tabs
                      value={activeTab}
                      onChange={handleTabChange}
                      sx={{
                        minHeight:{xs:'28px',md:'32px',lg:'36px',xl:'48px'},
                        mb:{xs:0.5, lg:1},
                        '& .MuiTab-root': {
                          fontFamily:'Rubik',
                          fontWeight:600,
                          textTransform:'none',
                          minHeight:{xs:'28px',md:'32px',lg:'36px',xl:'48px'},
                          fontSize:{xs:'10px',md:'11px',lg:'13px',xl:'18px'},
                          padding:{xs:'4px 10px', xl:'8px 16px'},
                        },
                        '& .Mui-selected': {
                          color:'#08231B !important',
                        },
                        '& .MuiTabs-indicator': {
                          backgroundColor: theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main),
                        },
                      }}
                    >
                      <Tab label="Upload Documents" value="upload" />
                      <Tab label="Notes" value="notes" />
                    </Tabs>
                  </Box>

                  {activeTab === 'upload' && <Box sx={{flex:1, minHeight:0, display:'flex', flexDirection:'column'}}>
                  {   ((commonReducer?.event_details?.status_type_order < 3 || ( commonReducer.event_details?.revision?.submitted == false && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id)) ) &&   <Box  sx={{flexShrink:0, height:'100px', width: '90%' , minWidth: '320px', marginTop:{xs: '20px', md: '10px'}, marginBottom:{xs:'10px', sm:'15px',md:'5px',lg:'25px', xl:'70px'}}}>
                        <DocumentDropzone
                        flex='row'
                         accept={{
                          'application/pdf': ['.pdf'],
                          'application/msword': ['.doc'],
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
                          'application/vnd.ms-powerpoint': ['.ppt'],
                          'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
                          'text/plain': []
                      }}
                         files={selectedFiles}
                         setFiles={setSelectedFiles}
                         setUploadStatus={setUploadStatus}
                         uploadedFiles = {uploadedNotes}
                         setProgress={setProgress}
                         setRequestController={setRequestController}
                         category = {uploadCategory.notes}
                         extraPayload = {{event_id: commonReducer?.production_event_id}}
                         onFileSelection = {handleClose}
                         height={{xs: '80px',sm:'75px',md:'85px',lg:'105px', xl:'140px'}}
                       />
                        <Box className='flex row j-end ' gap={0.5} sx={{alignItems: 'flex-end'}} >
                            <Typography textAlign={"end"} sx={{fontSize: {xs:'9px',md:'10px',lg:'11px',xl:'15px'}, fontWeight:600, mt:'3px'}}>Upload files upto 100 mb.</Typography>
                            <CustomTooltip title=" Files Allowed: .pdf, .txt, .docx, .doc, .ppt, .pptx" >
                              <InfoOutlinedIcon sx={{fontSize: {xs:'9px !important',md:'9px !important',lg:'10.67px !important', xl:'16px !important'}, color: '#000000',  marginBottom: '2px'}} />
                            </CustomTooltip>
                          </Box>
                        </Box>}
                        <Box sx={{flex:1, minHeight:0}}  className= 'flex row j-between a-start' >

                          <Box pl={1} component='div' sx={{  maxHeight: {xs: '130px', sm: '120px', md: '210px', lg: '150px', xl: '215px'} ,  maxWidth:'85%', width:'85%'}}>

                            <UploadedDocumentsTable
                              progress= {progress}
                              uploadStatus = {uploadStatus}
                              uploadedNotes={uploadedNotes}
                              height={{xs: '100px',sm:'85px',md:'100px',lg:'140px', xl:'180px'}}
                              setUploadedNotes={setUploadedNotes}
                            />

                          </Box>
                    </Box>
                  </Box>}

                  {activeTab === 'notes' && <Box className='flex col' sx={{flex:1, minHeight:0 }}>
                    <Box className='flex j-end a-center' mb={1} gap={2} sx={{flexShrink:0}}>
                      {(editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) &&
                        <CustomButton
                        btnText={'Cancel'}
                        onClick={convertToViewMode}
                        type='button'
                        color='secondary'
                        variant='outlined'
                        disabled={ commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null}
                        style={{
                          borderRadius: '5px',
                          border: "none",
                          textTransform:'none',
                        }}
                        sx={{fontSize:{xs:'9px',sm:'10px',lg:'12px',xl:'18px'},  fontWeight:600, height:{xs:'22px',sm:'24px',lg:'28px',xl:"40px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
                      />
                      }
                      {( hasPermission(PERMISSION.PROJECT.INFO.EDIT) &&   ((commonReducer?.event_details?.status_type_order < 3 || ( commonReducer.event_details?.revision?.submitted == false && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id)) ) ) &&  <LoadingButton
                        onClick={(editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) ? saveEditNoteDescription : convertToEditMode}
                        type='button'
                        color='secondary'
                        variant='contained'
                        loading={projectReducer?.is_loading}
                        loadingPosition="end"
                        style={{
                          borderRadius: '5px',
                          border: "none",
                          textTransform:'none',
                        }}
                        endIcon={(editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) ? <SaveOutlinedIcon style={{fontSize:'15px'}} /> : <EditOutlinedIcon style={{fontSize:'15px'}} />}
                        sx={{fontSize:{xs:'9px',sm:'10px',lg:'12px',xl:'18px'},  fontWeight:600, height:{xs:'22px',sm:'24px',lg:'28px',xl:"40px"}, width: '100%', maxWidth: {xs:'120px', xl:'180px'} , fontFamily:'Rubik'}}
                      >{(editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) ? 'Save' : 'Edit'}</LoadingButton>
                      }
                    </Box>

                    <Box className='flex' sx={{ flex:1, overflowY:'auto', minHeight:0 }} >
                    {(editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) ?   <TextField
                        sx={{mt:0.5, width:'100%', '& .MuiInputBase-root': {alignItems:'flex-start'}}}
                        id="outlined-multiline-static"
                        autoFocus
                        fullWidth
                        multiline
                        minRows={9}
                        maxRows={16}
                        inputProps={{
                          maxLength: 60000
                        }}
                        placeholder="Please type your detailed notes here..."
                        onFocus={handleFocus}
                        defaultValue={commonReducer?.event_details?.description}
                        onChange={(event) => setDescription(event.target.value)}
                        value={description}

                         /> : (
                            <Typography style={{ whiteSpace: "pre-line", wordBreak:'break-all' }}   sx={{mt:0.5}}>{commonReducer?.event_details?.description}</Typography>
                         )}
                    </Box>
                  </Box>}

                  <Box className='flex j-end a-end' mt={1} sx={{flexShrink:0}}>
                     <CheckIcon
                        onClick={activeTab === 'upload' ? handleClose : (!(editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) ? handleClose : null)}
                        color={theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main)}
                        sx={{
                          fontSize:{xs:'28px',sm:'30px',md:'42px', lg:'56px',xl:'75px'},
                          cursor: activeTab === 'upload' ? 'pointer' : (!(editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) && 'pointer'),
                          opacity: activeTab === 'upload' ? 0.5 : ((editMode || commonReducer?.event_details?.description == '' || commonReducer?.event_details?.description == null ) ? 0.6 : 1),
                        }}
                     />
                  </Box>
              </Box>
          </Box>

        </CustomAlert>
      )
}

export default UploadDocumentsPopup
